import styled from 'styled-components'
import backgroundDetails from '../../assets/images/backgroundDetails.png'
import { colors } from '../../theme'

export const DivTop = styled.div`
  display: flex;
  align-items: center;
`
export const Span = styled.span`
  margin-left: 15px;
  font-family: 'Sora';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
`
export const DivImg = styled.div`
  background: ${colors.surface} url('${backgroundDetails}') no-repeat center
    center;
  border-radius: 24px;
  padding: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
`
export const DivHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`
export const ButtonGerarPdf = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  /* Mesmo tratamento do botao "GERAR PDF" do modal Criar pedido
     (components/CriarPedido/styles.ts, BtnPdf): contorno verde sobre a
     superficie, com o texto no verde claro. A borda e o que da silhueta — sem
     ela, o botao teria a mesma cor do bloco do cabecalho e sumiria. */
  background-color: ${colors.surface};
  color: ${colors.primaryText};
  border: 1px solid ${colors.secondary};
  border-radius: 8px;
  padding: 10px 18px;
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`
export const DivName = styled.div`
  color: ${colors.white};
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
`
export const SpanData = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${colors.white};
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.2px;
  margin-top: 10px;
`

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .firstCard {
    width: 41%;
  }
  .secondCard {
    width: 57%;
  }
`
export const ContainerCard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const ButtonIsProdutosEmAltaEmBaixa = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`

export const Wrapper = styled.div<{ size?: string; alinhamento?: boolean }>`
  width: ${({ size }) => `${size}%`};
  padding: 20px;
  box-shadow: 0px 7px 30px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  background-color: ${colors.surface};
  align-items: ${({ alinhamento }) => `${alinhamento ? 'end' : 'start'}`};
  display: flex;
  flex-direction: column;
  justify-content: ${({ alinhamento }) =>
    `${alinhamento ? 'space-between' : ''}`};
`
export const DivTablePaginacao = styled.div`
  width: 100%;
`

export const DivButtonHistoricoBaixa = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
`
export const DivButtonHistoricoBaixaCriarPedido = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`

export const IconDismiss = styled.div`
  cursor: pointer;
`
export const LinkWpp = styled.a`
  color: ${colors.white};
  text-decoration: none;
`

export const TypesFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 6px;
  height: 42px;
  font-size: 12px;
  border-radius: 8px;
`

export const FiltersCalendar = styled.button`
  display: flex;
  align-items: center;
  justify-content: left;
  background: none;
  border: none;
  height: 100%;
  width: 100%;
  gap: 5px;

  > button {
    height: auto;
    min-height: 40px;
    padding: 6px 10px;
    line-height: 1.2;
  }
`
export const Calendars = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  font-size: 13px;
`
export const DatePickerStyle = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  gap: 5px;
  color: ${colors.grey700};
`

export const TitleAndCalendar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
export const ButtonHistoricoBaixa = styled.label`
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  color: ${colors.grey700};
  background-color: ${colors.grey300};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 8px 15px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  width: 190px;
  height: 34px;
  margin-top: 15px;
`
